import React from 'react';
import { Route, Routes, } from "react-router-dom";
import PRIVATE from 'components/cmp_routes/cmp_private'
import PUBLIC from 'components/cmp_routes/cmp_public'

// public
import SIGNIN from './containers/signin/signin'
import NOTFOUND from './containers/misc/notfound'

//  activities
import ACTIVITIES from './containers/activities/activities_list/activities_list'
import ACTIVITY_DETAILS from './containers/activities/activity_details/activity_details'

//searches
import SEARCHES from './containers/searches/searches'

//providers
import PROVIDERS from './containers/providers/providers_list/providers_list'
import PROVIDER_DETAILS from './containers/providers/provider_details/provider_details'

//domains
import DOMAINS_LIST from 'containers/domains/domains_list/domains_list'



export default function Links({ appProps }) {

    return (
        <Routes>
            <Route path="/" element={<PUBLIC> <SIGNIN/> </PUBLIC> } />
            <Route path="/domains" element={ <PRIVATE> <DOMAINS_LIST/> </PRIVATE>} />
            <Route path="/providers" element={ <PRIVATE> <PROVIDERS/> </PRIVATE>} />
            <Route path="/provider/:provider_id" element={ <PRIVATE> <PROVIDER_DETAILS/> </PRIVATE>} />
            <Route path="/searches" element={ <PRIVATE> <SEARCHES/> </PRIVATE>} />
            <Route path="/activities" element={ <PRIVATE> <ACTIVITIES/> </PRIVATE>} />
            <Route path="/activity/:activity_id" element={ <PRIVATE> <ACTIVITY_DETAILS/> </PRIVATE>} />
            <Route path="*" element={<NOTFOUND/>} />;
        </Routes>
    );
}
